<template>
  <q-page id="marketplace">
    <div class="q-pa-md">
      <sem-permissao v-if="!permissao"></sem-permissao>
      <div v-if="permissao">
        <q-table
          id="table-vendas-mkp"
          dense
          title="Vendas"
          :rows="vendas"
          :columns="columns"
          :loading="loadingVendas"
          :bottom="false"
          v-model:pagination="pagination"
          row-key="id"
          :no-data-label="'Nenhum dado'"
          :no-results-label="'Nenhum resultado obtido'"
          :loading-label="'Carregando dados'">
            <template v-slot:top>
              <q-btn
                flat
                id="addVendaMkp"
                round
                dense
                icon="add"
                class="q-ml-md text-primary"
                style="margin-right: 10px;margin-left: 0"
                @click="novaVendamkp()"
              />
              <div class="q-table__title">Vendas do Marketplace</div>
              <q-space />

              <q-btn-group id="" rounded flat no-wrap no-caps>
                <q-btn
                  class="white text-blue-7"
                  clickable
                  @click="changeFilterPeriodo('prev')"
                  rounded
                  icon="chevron_left"
                />
                <q-btn
                  class="white text-blue-7"
                  rounded
                  :label="filtrosDtiniFormatted"
                >
                  <template v-slot:default>
                    <q-popup-proxy ref="qDateDtini" transition-show="scale" transition-hide="scale">
                      <q-date
                        mask="DD/MM/YYYY"
                        :locale="langDate"
                        minimal
                        today-btn
                        v-model="filtrosDtiniFormatted"
                        @update:model-value="value => alterarDataInicio(value)"
                      />
                    </q-popup-proxy>
                  </template>
                </q-btn>
                <q-btn
                  class="white text-blue-7"
                  rounded
                  :label="filtrosDtfimFormatted"
                >
                  <template v-slot:default>
                    <q-popup-proxy ref="qDateDtfim" transition-show="scale" transition-hide="scale">
                      <q-date
                        mask="DD/MM/YYYY"
                        :locale="langDate"
                        minimal
                        today-btn
                        v-model="filtrosDtfimFormatted"
                        @update:model-value="value => alterarDataFim(value)"
                      />
                    </q-popup-proxy>
                  </template>
                </q-btn>
                <q-btn
                  class="white text-blue-7"
                  clickable
                  @click="changeFilterPeriodo('next')"
                  rounded
                  icon="chevron_right"
                />
              </q-btn-group>

            </template>
            <template v-slot:body="props">
              <q-tr>
                <q-td key="id" class="text-center">
                  {{ props.row.id}}
                </q-td>
                <q-td key="data" class="text-center">
                  {{ $formatDate(props.row.dtvenda) }}
                </q-td>
                <q-td key="data" class="text-center">
                  {{ $formatDate(props.row.dtmovimento) }}
                </q-td>
                <q-td key="status">
                  {{props.row.status}}
                  <br>
                  <div v-if="props.row.status == 'Aberta'">Em: {{ $formatDateTime(props.row.created) }} por {{props.row.created_by}}</div>
                  <div v-if="props.row.status == 'Finalizada'">Em: {{ $formatDateTime(props.row.modified) }} por {{props.row.created_by}}</div>
                  <div v-if="props.row.status == 'Cancelada'">Em: {{ $formatDateTime(props.row.modified) }} por {{props.row.created_by}}</div>
                </q-td>
                <q-td key="creditos" class="text-right">
                  R$ {{ $currency(props.row.vlrcreditos) }}
                </q-td>
                <q-td key="debitos" class="text-right">
                  R$ {{ $currency(props.row.vlrdebitos) }}
                </q-td>
                <q-td v-if="$q.platform.is.desktop" class="tdfora">
                  <div class="divfora">
                    <div class="divdentro q-gutter-sm" style="margin-right: 10px">
                      <q-btn
                        @click="edit(props.row)"
                        size="12px"
                        color="secondary"
                        icon="edit"
                      ></q-btn>
                      <q-btn
                        @click="cancelar(props.row)"
                        class="bg-negative text-white"
                        icon="delete_forever"
                        size="12px"
                      ></q-btn>

                    </div>
                  </div>
                </q-td>
              </q-tr>
              <q-tr v-show="props.expand" :props="props">
                <q-td colspan="100%">
                  <div class="q-py-sm q-gutter-sm">
                    <q-btn
                      @click="edit(props.row)"
                      size="12px"
                      class="bg-primary text-white"
                      icon="edit"
                    />
                    <q-btn
                      @click="cancelar(props.row)"
                      class="bg-negative text-white"
                      icon="delete_forever"
                      size="12px"
                    ></q-btn>

                  </div>
                </q-td>
              </q-tr>
            </template>

            <template v-slot:bottom></template>
        </q-table>

        <div>
          <q-page-sticky position="top-right" :offset="[0, 90]">
              <q-btn
                id="opcoesMkp"
                :color="openOpcoesAvancadasMkp ? 'red-7' : 'blue-7'"
                :icon="openOpcoesAvancadasMkp ? 'close' : 'settings'"
                class="rotate-0"
                style="border-top-left-radius: 50px;border-bottom-left-radius: 50px;"
                @click="openOpcoesAvancadasMkp = !openOpcoesAvancadasMkp"
              >
                <q-tooltip
                  :class="
                    openOpcoesAvancadasMkp
                      ? 'bg-negative text-white text-center'
                      : 'bg-secondary text-white text-center'
                  "
                  >{{
                    openOpcoesAvancadasMkp ? "Fechar Opções Avançadas" : "Opções Avançadas"
                  }}</q-tooltip
                >
              </q-btn>
          </q-page-sticky>

          <q-drawer
              side="right"
              v-model="openOpcoesAvancadasMkp"
              bordered
              :width="300"
              :breakpoint="500"
              behavior="default"
              class="bg-white"
            >
              <q-scroll-area class="fit">
                <div class="q-pa-sm">
                  <div class="q-table__title">Opções Avançadas</div>
                  <div>
                    <q-list
                      class="rounded-borders"
                      style="max-width: 350px; margin-left: -10px;width: 300px;"
                    >
                      <q-item-label header></q-item-label>

                      <q-item clickable v-ripple @click.exact="abrirOpcoes()">
                        <q-item-section>
                          <q-item-label lines="1">Opções</q-item-label>
                          <q-item-label caption>Configurações do Marketplace</q-item-label>
                        </q-item-section>
                      </q-item>

                    </q-list>
                  </div>
                </div>
              </q-scroll-area>
          </q-drawer>

        </div>

        <q-dialog v-model="openDialogMkp" persistent>
          <q-card style="min-width: 1000px">
            <q-card-section class="row items-center">
              <div class="text-h6">Venda no Marketplace <span v-if="!isNew">ID:{{venda.id}} {{ venda.dtvenda }} {{ venda.status }}</span> </div>
              <q-space />
              <q-btn icon="close" flat round dense v-close-popup @click="closeModal()" />
            </q-card-section>

            <q-card-section>
              <div class="row q-col-gutter-sm">
                <div class="col-4">
                <q-input v-if="isNew" dense clearable bottom-slots label="Data da Venda"
                  :error="errors.dtvenda ? true : false" v-model="venda.dtvenda"
                  @click="$refs.qdtvenda.show()">
                  <template v-slot:append>
                    <q-icon name="event" class="cursor-pointer">
                      <q-popup-proxy ref="qdtvenda" transition-show="scale" transition-hide="scale">
                        <q-date v-model="venda.dtvenda" mask="DD/MM/YYYY"
                          :locale="langDate"
                          minimal
                          today-btn
                          @update:model-value="pulaProx('btnNovaVendaMkp')" />
                      </q-popup-proxy>
                    </q-icon>
                  </template>

                  <template v-slot:error>
                    <span v-for="(error, i) in errors.dtvenda" :key="error + i">{{ error }}</span>
                  </template>
                </q-input>
                </div>
                <div class="col-8 pull-right" v-if="isNew">
                <q-btn
                  id="btnNovaVendaMkp"
                  color="primary"
                  label="Iniciar Venda"
                  class="q-mb-sm"
                  @click="iniciarVenda()"
                  :loading="saving"
                >
                </q-btn>
                </div>
              </div>
              <div class="row" v-if="!isNew">
                <div class="col-12">
                  <q-markup-table
                    dense
                    separator="none"
                    flat
                    bordered
                  >
                    <thead>
                      <tr>
                        <th class="text-left" style="min-width: 200px;">Produto</th>
                        <th class="text-left">
                          Estoque
                          <q-icon v-if="venda.status !== 'Aberta'" name="info" size="16px" class="q-ml-xs text-grey-6">
                            <q-tooltip style="custom-tooltip">Estoque no momento da Venda</q-tooltip>
                          </q-icon>
                        </th>
                        <th class="text-left">Quantidade</th>
                        <th class="text-left">Custo<br>Das Cotas
                          <q-icon name="info" size="16px" class="q-ml-xs text-grey-6">
                            <q-tooltip class="custom-tooltip">"Cotas Virtuais Vendidas MKP"
                            <br>Valor do Custo da Cota de Bolão (Custo do Jogo Jogado)
                            </q-tooltip>
                          </q-icon>
                        </th>
                        <th class="text-left">Custo Direto<br>Das Cotas
                          <q-icon name="info" size="16px" class="q-ml-xs text-grey-6">
                            <q-tooltip class="custom-tooltip">"Custeio Cotas Virtuais MKP"
                            <br>Custos Relacionados ao meio de pagamentos nas vendas apenas sobre as Cotas (Ex.: Cartão de Crédito)
                            </q-tooltip>
                          </q-icon>
                        </th>
                        <th class="text-left">Tarifa<br>Da Lotérica
                          <q-icon name="info" size="16px" class="q-ml-xs text-grey-6">
                            <q-tooltip class="custom-tooltip">"TS de Cotas Virtuais Vendidas MKP"
                            <br>Tarifação que a Lotérica Recebe por ter criado o Bolão (35%)</q-tooltip>
                          </q-icon>
                        </th>
                        <th class="text-left">Custo Direto<br>Da Tarifa
                          <q-icon name="info" size="16px" class="q-ml-xs text-grey-6">
                            <q-tooltip class="custom-tooltip">"Custeio TS de Cotas Virtuais MKP"
                            <br>Custos Relacionados ao meio de pagamentos nas vendas apenas sobre a Tarifação que a Lotérica tem por ter criado o Bolão</q-tooltip>
                          </q-icon>
                        </th>
                        <!-- <th>Valor de Venda
                          <q-icon name="info" size="16px" class="q-ml-xs text-grey-6">
                            <q-tooltip>Valor que as Cotas Foram Vendidas</q-tooltip>
                          </q-icon>
                        </th> -->
                      </tr>
                    </thead>
                    <tbody v-if="venda.status == 'Aberta'">
                      <tr v-if="!estoque || estoque.length === 0">
                        <td colspan="7" class="text-center text-grey-6 q-pa-md">
                          Nenhum produto no estoque para iniciar uma venda!
                        </td>
                      </tr>
                      <!--
                        No @keyup.tab on the fields of this grid. Tab has already moved focus
                        on keydown, so keyup lands on the NEXT field and navigating from there
                        skips one (and Shift+Tab bounces back). Under Vue 2 none of these
                        listeners ran, since neither wrapper emits them; under Vue 3 they fall
                        through to the native <input>.
                      -->
                      <tr v-for="(item, index) in estoque" :key="index">
                        <td class="text-left">{{item.nome}} {{item.concurso}}</td>
                        <td class="text-right">{{item.quantidade}}</td>
                        <td class="text-right">
                          <q-field
                            dense
                            style="width: 100px"
                            class="q-field--min-height-unset"
                            autocomplete="off"
                          >
                            <template v-slot:default>
                              <the-mask
                                autocomplete="off"
                                :mask="['######']"
                                placeholder=" "
                                :ref="'quantida' + index"
                                :id="'quantida' + index"
                                :tabindex="(index * 6) + 1"
                                :masked="true"
                                type="text"
                                style="text-align: right; width: 100%"
                                v-model="item.venda_quantidade"
                                @focus="currentField = 'quantida' + index"
                                @keyup.enter="navigateHorizontal(index, 'quantida', true)"
                                @keyup.up="navigateVertical(index, 'quantida', 'up')"
                                @keyup.down="navigateVertical(index, 'quantida', 'down')"
                              />
                            </template>
                          </q-field>
                        </td>
                        <td class="text-right">
                          <q-field
                            dense
                            style="width: 100px"
                            class="q-field--min-height-unset"
                            autocomplete="off"
                          >
                            <template v-slot:default>
                              <money-input
                                autocomplete="off"
                                type="text"
                                v-model="item.venda_vlrvenda"
                                v-bind="money"
                                style="text-align: right; width: 100%"
                                :ref="'valorv' + index"
                                :id="'valorv' + index"
                                :tabindex="(index * 6) + 2"
                                class="input-money"
                                @input="calcularComissao(item)"
                                @focus="currentField = 'valorv' + index"
                                @keyup.enter="navigateHorizontal(index, 'valorv', true)"
                                @keyup.up="navigateVertical(index, 'valorv', 'up')"
                                @keyup.down="navigateVertical(index, 'valorv', 'down')"
                              ></money-input>
                            </template>
                          </q-field>
                        </td>
                        <td class="text-right">
                          <q-field
                            dense
                            style="width: 100px"
                            class="q-field--min-height-unset"
                            autocomplete="off"
                          >
                            <template v-slot:default>
                              <money-input
                                autocomplete="off"
                                type="text"
                                v-model="item.venda_vlrcusto_venda"
                                v-bind="money"
                                style="text-align: right; width: 100%"
                                :ref="'valorc' + index"
                                :id="'valorc' + index"
                                :tabindex="(index * 6) + 3"
                                class="input-money"
                                @focus="currentField = 'valorc' + index"
                                @keyup.enter="navigateHorizontal(index, 'valorc', true)"
                                @keyup.up="navigateVertical(index, 'valorc', 'up')"
                                @keyup.down="navigateVertical(index, 'valorc', 'down')"
                              ></money-input>
                            </template>
                          </q-field>
                        </td>
                        <td class="text-right">
                          <q-field
                            dense
                            style="width: 100px"
                            class="q-field--min-height-unset"
                            autocomplete="off"
                          >
                            <template v-slot:default>
                              <money-input
                                autocomplete="off"
                                type="text"
                                v-model="item.venda_vlrcomissao"
                                v-bind="money"
                                style="text-align: right; width: 100%"
                                :ref="'custov' + index"
                                :id="'custov' + index"
                                :tabindex="(index * 6) + 4"
                                class="input-money"
                                @focus="currentField = 'custov' + index"
                                @keyup.enter="navigateHorizontal(index, 'custov', true)"
                                @keyup.up="navigateVertical(index, 'custov', 'up')"
                                @keyup.down="navigateVertical(index, 'custov', 'down')"
                              ></money-input>
                            </template>
                          </q-field>
                        </td>
                        <td class="text-right">
                          <q-field
                            dense
                            style="width: 100px"
                            class="q-field--min-height-unset"
                            autocomplete="off"
                          >
                            <template v-slot:default>
                              <money-input
                                autocomplete="off"
                                type="text"
                                v-model="item.venda_vlrcusto_comisao"
                                v-bind="money"
                                style="text-align: right; width: 100%"
                                :ref="'custoc' + index"
                                :id="'custoc' + index"
                                :tabindex="(index * 6) + 5"
                                class="input-money"
                                @focus="currentField = 'custoc' + index"
                                @keyup.enter="navigateHorizontal(index, 'custoc', true)"
                                @keyup.up="navigateVertical(index, 'custoc', 'up')"
                                @keyup.down="navigateVertical(index, 'custoc', 'down')"
                              ></money-input>
                            </template>
                          </q-field>
                        </td>
                        <!-- <td class="text-right">R$ {{ item.venda_vlrvenda + item.venda_vlrcomissao | currency}}</td> -->
                      </tr>
                    </tbody>
                    <!-- Tbody para vendas finalizadas (read-only) -->
                    <tbody v-else-if="venda.status !== 'Aberta' && venda.movvendasmkp_items">
                      <tr v-if="!venda.movvendasmkp_items || venda.movvendasmkp_items.length === 0">
                        <td colspan="7" class="text-center text-grey-6 q-pa-md">
                          Nenhum item na venda finalizada.
                        </td>
                      </tr>
                      <tr v-for="(item, index) in venda.movvendasmkp_items" :key="'final-' + index">
                        <!-- `item.produto && …` em vez de `item.produto?.nome`: o compilador de
                             template (buble) é ES2015 e não parseia optional chaining. Mesmo
                             resultado — se `produto` for nulo, cai no `||` do mesmo jeito. -->
                        <td class="text-left">{{ (item.produto && item.produto.nome) || 'Produto ' + item.produto_id }} {{ item.concurso || '' }}</td>
                        <td class="text-right">{{ item.estoque }} - {{ item.quantidade }} = {{item.estoque - item.quantidade}} </td>
                        <td class="text-right">{{ item.quantidade }}</td>
                        <td class="text-right">R$ {{ $currency(item.vlrvenda) }}</td>
                        <td class="text-right">R$ {{ $currency(item.vlrcusto_venda) }}</td>
                        <td class="text-right">R$ {{ $currency(item.vlrcomissao) }}</td>
                        <td class="text-right">R$ {{ $currency(item.vlrcusto_comisao) }}</td>
                        <!-- <td class="text-right">R$ {{ item.vlrvenda + item.vlrcomissao | currency }}</td> -->
                      </tr>
                    </tbody>
                  </q-markup-table>
                </div>
              </div>

              <!-- Seção de totais -->
              <div class="row q-mt-md" v-if="!isNew">
                <div class="col-12" v-if="venda.status == 'Finalizada'">
                  <q-card flat bordered class="q-pa-md">
                    <div class="row q-gutter-md justify-end">
                      <div class="col-auto text-right">
                        <div class="text-subtitle2">{{ venda.nomenclatura_vlrvenda }} R$</div>
                        <div class="text-subtitle2">{{ venda.nomenclatura_vlrcustovenda }} R$</div>
                        <div class="text-subtitle2">{{ venda.nomenclatura_vlrcomis }} R$</div>
                        <div class="text-subtitle2">{{ venda.nomenclatura_vlrcustocomis }} R$</div>
                        <div class="text-subtitle2">Total de Créditos R$</div>
                        <div class="text-subtitle2">Total de Débitos R$</div>
                        <div class="text-subtitle2">Créditos - Débitos R$</div>
                      </div>
                      <div class="col-auto text-right">
                        <div class="text-subtitle2">{{ $currency(venda.vlrvenda) }} </div>
                        <div class="text-subtitle2">-{{ $currency(venda.vlrcustovenda) }} </div>
                        <div class="text-subtitle2">{{ $currency(venda.vlrcomis) }} </div>
                        <div class="text-subtitle2">-{{ $currency(venda.vlrcustocomis) }} </div>
                        <div class="text-subtitle2">{{ $currency(venda.vlrcreditos) }}</div>
                        <div class="text-subtitle2">-{{ $currency(venda.vlrdebitos) }}</div>
                        <div class="text-subtitle2">{{ $currency(venda.vlrcreditos - venda.vlrdebitos) }}</div>
                      </div>
                    </div>
                  </q-card>
                </div>
              </div>

              <!-- Seção de erros de validação -->
              <div class="row q-mt-md" v-if="errors && errors.length > 0">
                <div class="col-12">
                  <div class="text-negative text-weight-bold q-mb-sm">Erros de validação:</div>
                  <div v-for="(errorItem, errorIndex) in errors" :key="errorIndex" class="q-mb-sm">
                    <div class="text-negative text-weight-medium">{{ errorItem.nome }} {{ errorItem.concurso || '' }}</div>
                    <div v-for="(errorMessages, field) in errorItem.errors" :key="field" class="q-ml-md">
                      <p v-for="(message, msgIndex) in errorMessages" :key="msgIndex" class="text-negative q-mb-xs">
                        • {{ message }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

            </q-card-section>

            <q-card-actions align="right" v-if="!isNew">
              <q-btn v-if="venda.status == 'Aberta'" id="btnSalvar" :tabindex="(estoque.length * 6) + 1" color="positive" :loading="saving" label="Salvar" @click="save" />
            </q-card-actions>
          </q-card>
        </q-dialog>

        <q-dialog v-model="openDialogOpcoesMkp" persistent>
          <q-card>
            <q-card-section class="row items-center">
              <div class="text-h6">Opções Marketplace</div>
              <q-space />
              <q-btn
                class="q-ml-lg"
                icon="close"
                flat
                round
                dense
                v-close-popup
                @click="closeDialogOpcoesMkp"
              />
            </q-card-section>

            <q-separator />

            <q-card-section>
              <div class="row q-col-gutter-md">
                <!-- Nomenclaturas -->
                <div class="col-12">
                  <div class="text-subtitle1">Nomenclaturas</div>
                </div>

                <div class="col-6">
                  <q-input
                    v-model="optionsMkp.marketplace_nomenclatura_vlrvenda"
                    label="Nomenclatura - Custo das Cotas"
                    dense
                  />
                </div>

                <div class="col-6">
                  <q-input
                    v-model="optionsMkp.marketplace_nomenclatura_vlrcustovenda"
                    label="Nomenclatura - Custo Direto das Cotas"
                    dense
                  />
                </div>

                <div class="col-6">
                  <q-input
                    v-model="optionsMkp.marketplace_nomenclatura_vlrcomis"
                    label="Nomenclatura - Tarifa da Lotérica"
                    dense
                  />
                </div>

                <div class="col-6">
                  <q-input
                    v-model="optionsMkp.marketplace_nomenclatura_vlrcustocomis"
                    label="Nomenclatura - Custo Direto da Tarifa"
                    dense
                  />
                </div>
                <!-- Contas -->
                <div class="col-12">
                  <div class="text-subtitle1 q-mt-md">Contas</div>
                </div>

                <div class="col-6">
                  <q-input
                    v-model="optionsMkp.marketplace_conta_vlrvenda"
                    label="Conta - Custo das Cotas"
                    dense
                  />
                </div>

                <div class="col-6">
                  <q-input
                    v-model="optionsMkp.marketplace_conta_vlrcustovenda"
                    label="Conta - Custo Direto das Cotas"
                    dense
                  />
                </div>

                <div class="col-6">
                  <q-input
                    v-model="optionsMkp.marketplace_conta_vlrcomis"
                    label="Conta - Tarifa da Lotérica"
                    dense
                  />
                </div>

                <div class="col-6">
                  <q-input
                    v-model="optionsMkp.marketplace_conta_vlrcustocomis"
                    label="Conta - Custo Direto da Tarifa"
                    dense
                  />
                </div>

                <!-- Planos de Conta -->
                <div class="col-12">
                  <div class="text-subtitle1">Planos de Conta</div>
                </div>

                <div class="col-6">
                  <q-input
                    v-model="optionsMkp.marketplace_planodeconta_id_vlrvenda"
                    label="Plano de Conta - Custo das Cotas"
                    dense
                  />
                </div>

                <div class="col-6">
                  <q-input
                    v-model="optionsMkp.marketplace_planodeconta_id_vlrcustovenda"
                    label="Plano de Conta - Custo Direto das Cotas"
                    dense
                  />
                </div>

                <div class="col-6">
                  <q-input
                    v-model="optionsMkp.marketplace_planodeconta_id_vlrcomis"
                    label="Plano de Conta - Tarifa da Lotérica"
                    dense
                  />
                </div>

                <div class="col-6">
                  <q-input
                    v-model="optionsMkp.marketplace_planodeconta_id_vlrcustocomis"
                    label="Plano de Conta - Custo Direto da Tarifa"
                    dense
                  />
                </div>

                <!-- Funcionário -->
                <div class="col-12">
                  <div class="text-subtitle1 q-mt-md">Funcionário</div>
                </div>

                <div class="col-12">
                  <q-input
                    v-model="optionsMkp.marketplace_funcionario_id"
                    label="ID do Funcionário do Marketplace"
                    dense
                  />
                </div>

              </div>
            </q-card-section>

            <q-card-section class="flex justify-end">
              <q-btn
                label="Salvar"
                color="green"
                :loading="saving"
                @click="saveOptionsMkp"
              />
            </q-card-section>
          </q-card>
        </q-dialog>

      </div>
    </div>
  </q-page>
</template>

<script>
import { createMetaMixin } from "quasar";
import axios from "@/axios-auth";
import moment from 'moment';
import MoneyInput from "@/components/Utils/money-input.vue";

export default {
  name: "maketplace",
  components: {
    MoneyInput
  },
  mixins: [createMetaMixin({ title: "DSB | Marketplace" })],
  data() {
    return {
      permissao: true,
      openDialogMkp: false,
      openOpcoesAvancadasMkp: false,
      openDialogOpcoesMkp: false,
      optionsMkp: {},
      venda: this.getNewVenda(),
      estoque: [],
      vendas: [],
      loadingVendas: false,
      saving: false,
      isNew: true,
      currentField: null,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        masked: false,
        precision: 2
      },
      filtros: {
        dtini: null,
        dtfim: null,
      },
      errors: [],
      paging: {
        page: 0,
        count: 0,
        prevPage: false,
        nextPage: true,
        pageCount: 0
      },
      pagination: {
        sortBy: "id",
        descending: true,
        page: 1,
        rowsPerPage: 0
      },
      columns: [
        { name: "id", label: "ID", field: "id", align: "center", sortable: true },
        { name: "venda", label: "Venda", field: "dtvenda", align: "center", sortable: true },
        { name: "movimento", label: "Movimento", field: "dtvenda", align: "center", sortable: true },
        { name: "status", label: "Status", field: "status", align: "left", sortable: true },
        { name: "creditos", label: "Créditos", field: "vlrcreditos", align: "right", sortable: true },
        { name: "debitos", label: "Débitos", field: "vlrdebitos", align: "right", sortable: true },
      ],
    };
  },
  computed: {
    filtrosDtiniFormatted: {
      get() {
        if (!this.filtros.dtini) return null;
        // Se já está no formato DD/MM/YYYY, retorna como está
        if (this.filtros.dtini.includes('/')) {
          return this.filtros.dtini;
        }
        // Converte de DD-MM-YYYY para DD/MM/YYYY
        return this.filtros.dtini.replace(/-/g, '/');
      },
      set(value) {
        // Converte de DD/MM/YYYY para DD-MM-YYYY para manter consistência com a API
        this.filtros.dtini = value ? value.replace(/\//g, '-') : null;
      }
    },
    filtrosDtfimFormatted: {
      get() {
        if (!this.filtros.dtfim) return null;
        // Se já está no formato DD/MM/YYYY, retorna como está
        if (this.filtros.dtfim.includes('/')) {
          return this.filtros.dtfim;
        }
        // Converte de DD-MM-YYYY para DD/MM/YYYY
        return this.filtros.dtfim.replace(/-/g, '/');
      },
      set(value) {
        // Converte de DD/MM/YYYY para DD-MM-YYYY para manter consistência com a API
        this.filtros.dtfim = value ? value.replace(/\//g, '-') : null;
      }
    }
  },
  watch: {
    estoque: {
      handler(newEstoque) {
        // Calcula os totais apenas se a venda estiver aberta
        if (this.venda.status === 'Aberta') {
          this.calcularTotais();
        }
      },
      deep: true // Para observar mudanças profundas no array e objetos
    }
  },
  methods: {
    listar() {

      if (this.loadingVendas){
        return;
      }
      if (!this.paging.nextPage) {
        return;
      }

      this.loadingVendas = true;

      let params = JSON.parse(JSON.stringify(this.filtros));
      params.page = this.paging.page + 1; // Incrementa a página atual

      axios
        .get("/marketplace", { params })
        .then(res => {
          this.vendas = this.vendas.concat(res.data.vendas);
          this.filtros = res.data.filters;
          this.paging = res.data.paging;
        })
        .catch(err => {
          if (err.response && err.response.status === 403) {
            this.permissao = false;
            this.vendas = [];
            this.$q.notify({
              color: "negative",
              message: "Você não tem permissão para acessar o Marketplace.",
              position: "top-right"
            });
          } else {
            this.$q.notify({
              color: "negative",
              message: "Erro ao carregar as vendas. Por favor, tente novamente.",
              position: "top-right"
            });
          }

        })
        .finally(() => {
          this.loadingVendas = false;
        });
    },
    handleScroll() {
      if (
        window.scrollY + 10 >=
        document.body.clientHeight - window.innerHeight
      ) {
        this.listar();
      }
    },
    alterarDataInicio(value) {
      this.filtrosDtiniFormatted = value;
      this.$refs.qDateDtini.hide();
      this.resetPaging();
      this.listar();
    },
    alterarDataFim(value) {
      this.filtrosDtfimFormatted = value;
      this.$refs.qDateDtfim.hide();
      this.resetPaging();
      this.listar();
    },
    changeFilterPeriodo(periodo) {
      if (this.buscando) return;

      let dtini = moment(this.filtros.dtini, 'DD-MM-YYYY');
      let dtfim = moment(this.filtros.dtfim, 'DD-MM-YYYY');

      if (periodo === 'prev') {
        dtini = dtini.subtract(1, 'months');
        dtfim = dtfim.subtract(1, 'months');
      }

      if (periodo === 'next') {
        dtini = dtini.add(1, 'months');
        dtfim = dtfim.add(1, 'months');
      }

      this.paging.page = 0; // Reseta a páginação ao mudar o período
      this.filtros.dtini = dtini.startOf('month').format('DD-MM-YYYY');
      this.filtros.dtfim = dtfim.endOf('month').format('DD-MM-YYYY');

      this.resetPaging();
      this.listar();
    },
    abrirOpcoes() {
      axios.get('/marketplace/options')
        .then(res => {
          if (!res.data.success) {
            this.$q.notify({
              color: "negative",
              message: "Erro ao carregar as opções do marketplace. Por favor, tente novamente.",
              position: "top-right"
            });
            return;
          }

          // Valores padrão para as opções
          const defaultOptions = {
              "marketplace_planodeconta_id_vlrvenda": "",
              "marketplace_planodeconta_id_vlrcustovenda": "",
              "marketplace_planodeconta_id_vlrcomis": "",
              "marketplace_planodeconta_id_vlrcustocomis": "",
              "marketplace_funcionario_id": "",
              "marketplace_conta_vlrvenda": "",
              "marketplace_conta_vlrcustovenda": "",
              "marketplace_conta_vlrcomis": "",
              "marketplace_conta_vlrcustocomis": "",
              "marketplace_nomenclatura_vlrvenda": "COTAS MKP",
              "marketplace_nomenclatura_vlrcustovenda": "REB COT VT",
              "marketplace_nomenclatura_vlrcomis": "TRF MKP",
              "marketplace_nomenclatura_vlrcustocomis": "CUSTO TRF"
          };

          // Mescla os dados da API com os valores padrão
          this.optionsMkp = { ...defaultOptions, ...(res.data.options || {}) };
          this.openDialogOpcoesMkp = true;
        })
        .catch(err => {
          this.$q.notify({
            color: "negative",
            message: "Erro ao carregar as opções do marketplace. Por favor, tente novamente.",
            position: "top-right"
          });
        });
    },
    closeDialogOpcoesMkp() {
      this.openDialogOpcoesMkp = false;
    },
    saveOptionsMkp() {
      this.saving = true;

      axios.post('/marketplace/options', this.optionsMkp)
        .then(res => {
          if (!res.data.success) {
            this.$q.notify({
              color: "negative",
              message: res.data.message || "Erro ao salvar as opções do marketplace. Por favor, tente novamente.",
              position: "top-right"
            });
            return;
          }

          this.$q.notify({
            color: "positive",
            message: "Opções salvas com sucesso!",
            position: "top-right"
          });
          this.closeDialogOpcoesMkp();
        })
        .catch(err => {
          this.$q.notify({
            color: "negative",
            message: "Erro ao salvar as opções do marketplace. Por favor, tente novamente.",
            position: "top-right"
          });
        })
        .finally(() => {
          this.saving = false;
        });
    },
    calcularComissao(item) {
      if (item.venda_vlrvenda && parseFloat(item.venda_vlrvenda) > 0) {
        const valorVenda = parseFloat(item.venda_vlrvenda) || 0;
        item.venda_vlrcomissao = valorVenda * 0.35;
        this.calcularTotais();
      }
    },
    resetPaging() {
      let paging = {
        page: 0,
        count: 0,
        prevPage: false,
        nextPage: true,
        pageCount: 0
      };
      this.vendas = [];
      this.paging = paging;
    },
    openModal() {
      this.isNew = true;
      this.venda = this.getNewVenda();
      this.errors = [];
      this.openDialogMkp = true;
    },
    getNewVenda() {
      return {
        id: null,
        dtvenda: moment().format('DD/MM/YYYY'),
        funcionario_id: null,
        vlrcreditos: 0,
        vlrdebitos: 0,
        status: "ativo",
      };
    },
    closeModal() {
      this.openDialogMkp = false;
      this.resetForm();
    },
    resetForm() {
      this.venda = this.getNewVenda();
      this.errors = [];
      this.isNew = true;
    },
    novaVendamkp() {
      this.openModal();
    },
    iniciarVenda() {

      if (!this.venda.dtvenda) {
        this.errors = { dtvenda: ["Data da venda é obrigatória."] };
        return;
      }
      this.errors = [];

      this.$q.dialog({
        title: 'Confirmação',
        message: `Confirma a data da venda: ${this.venda.dtvenda}?`,
        cancel: true,
        persistent: true
      }).onOk(() => {
        this.saving = true;
        let dt = this.venda.dtvenda.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1');

        axios.post('/marketplace/add', {
          dtvenda: dt
        })
        .then(res => {

          if (!res.data.success) {
            this.$q.notify({
              color: "negative",
              message: "Erro ao iniciar a venda. Por favor, tente novamente.",
              position: "top-right"
            });
            this.errors = res.data.errors || {};
            return;
          }

          this.venda = res.data.venda;
          this.venda.dtvenda = moment(this.venda.dtvenda).format('DD/MM/YYYY');
          this.estoque = res.data.estoque || [];

          this.isNew = false;

          // Usar nextTick com timeout para garantir que o DOM foi atualizado
          this.$nextTick(() => {
            setTimeout(() => {
              // Busca o primeiro input de quantidade
              const firstInput = document.getElementById('quantida0') ||
                                document.querySelector('[tabindex="1"]') ||
                                document.querySelector('input[id*="quantida0"]');

              if (firstInput) {
                firstInput.focus();
                firstInput.select();
              }
            }, 300);
          });

          this.resetPaging();
          this.listar();

        })
        .catch(() => {
            this.$q.notify({
              color: "negative",
              message: "Erro ao iniciar a venda. Por favor, tente novamente.",
              position: "top-right"
            });
        })
        .finally(() => {
          this.saving = false;
        });
      });
    },
    edit(venda) {
      this.isNew = false;
      this.venda = { ...venda }; // Clona o objeto para evitar mutações diretas
      this.venda.dtvenda = moment(this.venda.dtvenda).format('DD/MM/YYYY');
      this.errors = [];

      // Carrega o estoque relacionado à venda
      axios.get(`/marketplace/edit/${this.venda.id}`)
        .then(res => {
          this.venda = res.data.venda;
          this.venda.dtvenda = moment(this.venda.dtvenda).format('DD/MM/YYYY');
          this.estoque = res.data.estoque || [];
          this.isNew = false;
          this.openDialogMkp = true;
        })
        .catch(() => {
          this.$q.notify({
            color: "negative",
            message: "Erro ao carregar o estoque da venda. Por favor, tente novamente.",
            position: "top-right"
          });
        });

    },
    save() {
      this.saving = true;

      // Filtra apenas os itens do estoque que têm venda_quantidade > 0
      const itensParaVenda = this.estoque.filter(item =>
        item.venda_quantidade && parseFloat(item.venda_quantidade) > 0
      );

      if (itensParaVenda.length === 0) {
        this.$q.notify({
          color: "negative",
          message: "Adicione pelo menos um item com quantidade para finalizar a venda.",
          position: "top-right"
        });
        this.saving = false;
        return;
      }

      // Prepara os dados conforme o formato esperado pela API
      const dadosVenda = itensParaVenda.map(item => ({
        produto_id: item.produto_id,
        nome: item.nome,
        ordem: item.ordem,
        tpcontrole: item.tpcontrole,
        evento_id: item.evento_id,
        evento: item.evento,
        ano: item.ano,
        extracao: item.extracao,
        concurso: item.concurso,
        vencimento: item.vencimento,
        quantidade: parseFloat(item.quantidade) || 0,
        valor: parseFloat(item.valor) || 0,
        tipo: item.tipo || "P",
        venda_quantidade: parseFloat(item.venda_quantidade) || 0,
        venda_vlrvenda: parseFloat(item.venda_vlrvenda) || 0,
        venda_vlrcomissao: parseFloat(item.venda_vlrcomissao) || 0,
        venda_vlrcusto_venda: parseFloat(item.venda_vlrcusto_venda) || 0,
        venda_vlrcusto_comisao: parseFloat(item.venda_vlrcusto_comisao) || 0,
        venda_meiopgto: ""
      }));

      const url = `/marketplace/edit/${this.venda.id}?type=finalizar`;

      axios.post(url, dadosVenda)
        .then(res => {
          if (!res.data.success) {

            this.$q.notify({
              color: "negative",
              message: res.data.message || "Erro ao finalizar a venda. Por favor, tente novamente.",
              position: "top-right"
            });

            this.errors = res.data.errors || [];
            return;
          }

          this.$q.notify({
            color: "positive",
            message: "Venda finalizada com sucesso!",
            position: "top-right"
          });

          this.resetForm();
          this.closeModal();
          this.resetPaging();
          this.listar();
        })
        .catch(err => {
          this.$q.notify({
            color: "negative",
            message: "Erro ao finalizar a venda. Por favor, tente novamente.",
            position: "top-right"
          });
        })
        .finally(() => {
          this.saving = false;
        });
    },
    cancelar(venda) {

      this.$q.dialog({
        title: "Cancelar a Venda",
        message: `Deseja cancelar a venda "${venda.id}" e reaver o estoque?`,
        cancel: true,
        persistent: true
      }).onOk(() => {

        axios.post(`/marketplace/delete/${venda.id}`)
          .then((res) => {
            if (!res.data.success) {
              this.$q.notify({
                color: "negative",
                message: res.data.message || "Erro ao excluir Venda. Por favor, tente novamente.",
                position: "top-right"
              });
              return;
            }

            this.$q.notify({
              color: "positive",
              message: res.data.message || "Venda cancelada com sucesso!",
              position: "top-right"
            });
            this.resetPaging();
            this.listar();
          })
          .catch(() => {
            this.$q.notify({
              color: "negative",
              message: "Erro ao cancelar Venda. Por favor, tente novamente.",
              position: "top-right"
            });
          });
      });
    },
    navigateHorizontal(index, currentField, forward = true) {
      const fields = ['quantida', 'valorv', 'valorc', 'custov', 'custoc'];
      const currentFieldIndex = fields.indexOf(currentField);

      let nextField, nextIndex;

      if (forward) {
        if (currentFieldIndex < fields.length - 1) {
          // Próximo campo na mesma linha (direita)
          nextField = fields[currentFieldIndex + 1];
          nextIndex = index;
        } else {
          // Última coluna: vai para primeira coluna da próxima linha
          nextField = fields[0];
          nextIndex = index + 1;
        }
      } else {
        if (currentFieldIndex > 0) {
          // Campo anterior na mesma linha (esquerda)
          nextField = fields[currentFieldIndex - 1];
          nextIndex = index;
        } else {
          // Primeira coluna: vai para última coluna da linha anterior
          nextField = fields[fields.length - 1];
          nextIndex = index - 1;
        }
      }

      this.focusField(nextField, nextIndex);
    },
    navigateVertical(index, fieldType, direction) {
      const nextIndex = direction === 'down' ? index + 1 : index - 1;
      this.focusField(fieldType, nextIndex);
    },
    focusField(fieldType, index) {
      if (index < 0 || index >= this.estoque.length) {
        if (index >= this.estoque.length) {
          // Foca no botão salvar se chegou ao final
          const btnSalvar = document.getElementById('btnSalvar');
          btnSalvar?.focus();
        }
        return;
      }

      const fieldId = `${fieldType}${index}`;

      this.$nextTick(() => {
        const element = document.getElementById(fieldId);
        if (element) {
          element.focus();
          element.select();
        }
      });
    },
    pulaProx(index, nextField, direction = 'next') {
      let targetIndex = index;
      let targetField = nextField;

      // Casos especiais para navegação de campos não-tabulares
      if (typeof index === 'string') {
        switch (index) {
          case "dtvenda":
            this.$refs.qdtvenda.show();
            break;
          case "btnNovaVendaMkp":
            this.$refs.qdtvenda.hide();
            break;
        }
        return;
      }

      // Navegação vertical (para próxima/anterior linha)
      if (direction === 'next') {
        targetIndex = index + 1;
      } else if (direction === 'previous') {
        targetIndex = index - 1;
      }

      // Verifica se existe próxima linha
      if (targetIndex >= this.estoque.length) {
        // Se chegou ao final, foca no botão salvar
        this.$nextTick(() => {
          const btnSalvar = document.getElementById('btnSalvar');
          btnSalvar?.focus();
        });
        return;
      }

      // Verifica se existe linha anterior
      if (targetIndex < 0) {
        targetIndex = 0;
      }

      // Constrói o nome da referência
      const refName = `${targetField}${targetIndex}`;

      // Foca no campo usando nextTick para garantir que o DOM foi atualizado
      this.$nextTick(() => {
        const targetElement = this.$refs[refName];
        if (targetElement) {
          if (Array.isArray(targetElement)) {
            targetElement[0]?.focus();
          } else {
            targetElement.focus();
          }
        } else {
          // Fallback para getElementById se ref não funcionar
          const element = document.getElementById(refName);
          element?.focus();
        }
      });
    },
    calcularTotais() {
      // Só calcula os totais se a venda estiver aberta
      if (!this.venda || this.venda.status !== 'Aberta') {
        return;
      }

      if (!this.estoque || this.estoque.length === 0) {
        this.venda.vlrcreditos = 0;
        this.venda.vlrdebitos = 0;
        return;
      }

      let totalCreditos = 0;
      let totalDebitos = 0;

      this.estoque.forEach(item => {
        // Verifica se o item tem quantidade de venda preenchida
        const quantidade = parseFloat(item.venda_quantidade) || 0;

        if (quantidade > 0) {
          // Calcula créditos: valor da venda + valor da comissão (valores já finais)
          const vlrVenda = parseFloat(item.venda_vlrvenda) || 0;
          const vlrComissao = parseFloat(item.venda_vlrcomissao) || 0;
          totalCreditos += vlrVenda + vlrComissao;

          // Calcula débitos: custo da venda + custo da comissão (valores já finais)
          const custoVenda = parseFloat(item.venda_vlrcusto_venda) || 0;
          const custoComissao = parseFloat(item.venda_vlrcusto_comisao) || 0;
          totalDebitos += custoVenda + custoComissao;
        }
      });

      this.venda.vlrcreditos = totalCreditos;
      this.venda.vlrdebitos = totalDebitos;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.listar();
  },
  beforeRouteLeave(to, from, next) {
    window.removeEventListener("scroll", this.handleScroll);
    next();
  },

};
</script>

<style lang="stylus" scoped>
.q-table__title {
  font-weight: 300;
  font-size: 25px;
}

.tdfora {
  position: relative;
  min-width: 32px;
  vertical-align: middle;
  white-space: nowrap;
  cursor: pointer;
}

.divfora {
  background: inherit;
  position: absolute;
  right: 1px;
  top: 0.25rem;
  display: none;
}

.divdentro {
  display: flex;
}

tr:hover .tdfora {
  .divfora {
    display: inline-block;
  }
}

.active_status {
  background-color: #ff9c00 !important;
  color: white !important;
}
</style>
